import { Box, styled } from '@mui/material';

export const PageContainer = styled(Box)(() => ({
  padding: '24px',
  paddingTop: '100px'
}));

export const SearchContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  justifyContent: 'start',
  '@media (max-width:586px)': {
    gap: 2,
    alignItems: 'start',
    flexDirection: 'column'
  }
}));

export const SearchItemContainer = styled(Box)(() => ({
  width: '170px',
  '@media (max-width:586px)': {
    width: '100%'
  }
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  marginTop: 24,
  justifyContent: 'flex-end',
  width: '100%'
}));